import React from "react";

interface ObjectivesSkeletonProps {
  count?: number;
}

export default function ObjectivesSkeleton({ count = 4 }: ObjectivesSkeletonProps) {
  return (
    <div className="space-y-4">
      {/* Actions Bar Skeleton */}
      <div className="p-4 bg-raro-gray-50 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="animate-pulse h-8 bg-raro-gray-200 rounded w-32"></div>
            <div className="animate-pulse h-8 bg-raro-gray-200 rounded w-36"></div>
          </div>
          <div className="animate-pulse h-4 bg-raro-gray-200 rounded w-20"></div>
        </div>
      </div>

      {/* Objective Cards Skeletons */}
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="bg-white border border-raro-gray-200 rounded-lg p-4 animate-pulse">
          <div className="flex items-start space-x-3">
            {/* Index Number Skeleton */}
            <div className="flex-shrink-0 w-6 h-6 bg-raro-gray-200 rounded-full mt-1"></div>

            {/* Content Skeleton */}
            <div className="flex-1 space-y-3">
              {/* First line */}
              <div className="h-4 bg-raro-gray-200 rounded w-full"></div>
              {/* Second line */}
              <div className="h-4 bg-raro-gray-200 rounded w-4/5"></div>
              {/* Third line - varies by index */}
              <div className={`h-4 bg-raro-gray-200 rounded ${
                index % 3 === 0 ? 'w-3/5' : 
                index % 3 === 1 ? 'w-5/6' : 'w-2/3'
              }`}></div>
            </div>

            {/* Actions Skeleton */}
            <div className="flex-shrink-0 flex items-center space-x-1">
              <div className="w-8 h-8 bg-raro-gray-200 rounded"></div>
              <div className="w-8 h-8 bg-raro-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      ))}

      {/* Loading Status */}
      <div className="text-center py-4">
        <div className="animate-pulse flex items-center justify-center space-x-2">
          <div className="w-4 h-4 bg-primary-300 rounded-full animate-bounce"></div>
          <div className="w-4 h-4 bg-primary-300 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-4 h-4 bg-primary-300 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
        <p className="text-primary-600 font-medium mt-2">Gerando objetivos SMART...</p>
        <p className="text-sm text-raro-gray-500 mt-1">A IA está analisando a descrição do projeto</p>
      </div>
    </div>
  );
}